var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbededIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.72985,
    y: 1.40343,
    width: 20.1931,
    height: 20.1931,
    rx: 0.989857,
    strokeWidth: 1.97971
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.72985,
    y: 11.3008,
    width: 10.6905,
    height: 10.2945,
    rx: 0.989857,
    strokeWidth: 1.97971
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbededIcon);
export default __webpack_public_path__ + "static/media/Embeded Icon.3005ca5c9dea5c698682d12dc3dd5af6.svg";
export { ForwardRef as ReactComponent };